var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2755 1.99235C7.04761 1.99235 1.17594 7.86402 1.17594 15.0919C1.17594 22.3202 7.04803 28.1876 14.2755 28.1876C21.503 28.1876 27.3751 22.3202 27.3751 15.0919C27.3751 7.86402 21.5034 1.99235 14.2755 1.99235Z",
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 2.0153
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1041_7273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5942 11.0156L8.99167 17.6187C8.95845 17.652 8.93447 17.6941 8.92305 17.7393L8.19122 20.6767C8.16933 20.7651 8.19531 20.8591 8.25984 20.9237C8.30867 20.9725 8.3752 20.9995 8.44325 20.9995C8.46409 20.9995 8.48542 20.997 8.50616 20.9917L11.4436 20.2598C11.4894 20.2484 11.531 20.2245 11.5642 20.1913L18.1673 13.5887L15.5942 11.0156Z",
    fill: "#00243C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8034 10.1149L19.0684 9.37995C18.5772 8.88874 17.721 8.88921 17.2304 9.37995L16.3301 10.2803L18.9031 12.8532L19.8034 11.9529C20.0487 11.7077 20.1839 11.3812 20.1839 11.034C20.1839 10.6868 20.0487 10.3603 19.8034 10.1149Z",
    fill: "#00243C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1041_7273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(8.18359 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/pen-icon.2545d5721248a5f64fcc1c590e7e490d.svg";
export { ForwardRef as ReactComponent };